'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_ValidEvent$() {
}
export { $c_Ldev_cheleb_scalamigen_ValidEvent$ as $c_Ldev_cheleb_scalamigen_ValidEvent$ };
$p = $c_Ldev_cheleb_scalamigen_ValidEvent$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_ValidEvent$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_ValidEvent$() {
}
export { $h_Ldev_cheleb_scalamigen_ValidEvent$ as $h_Ldev_cheleb_scalamigen_ValidEvent$ };
$h_Ldev_cheleb_scalamigen_ValidEvent$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 1924099102;
});
$p.b = (function() {
  return "ValidEvent";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "ValidEvent";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.y = (function(p) {
  return this;
});
var $d_Ldev_cheleb_scalamigen_ValidEvent$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_ValidEvent$, "dev.cheleb.scalamigen.ValidEvent$", ({
  jh: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ldev_cheleb_scalamigen_ValidEvent$ as $d_Ldev_cheleb_scalamigen_ValidEvent$ };
var $n_Ldev_cheleb_scalamigen_ValidEvent$;
function $m_Ldev_cheleb_scalamigen_ValidEvent$() {
  if ((!$n_Ldev_cheleb_scalamigen_ValidEvent$)) {
    $n_Ldev_cheleb_scalamigen_ValidEvent$ = new $c_Ldev_cheleb_scalamigen_ValidEvent$();
  }
  return $n_Ldev_cheleb_scalamigen_ValidEvent$;
}
export { $m_Ldev_cheleb_scalamigen_ValidEvent$ as $m_Ldev_cheleb_scalamigen_ValidEvent$ };
